import z from "zod";
import { addressSchema } from "../address";
import { contactMemberSchema } from "../contact";
import { ZodDateString } from "../zod-types/zod-date-string";

const substitutionPlanNotificationContentSchema = z.object({
	orgId: z.string(),
	startDate: ZodDateString,
	endDate: ZodDateString,
	user: z.object({
		firstName: z.string(),
		lastName: z.string(),
		email: z.string(),
	}),
});

export const substitutionPlanNotificationExternalContentSchema = z
	.object({
		contactMember: contactMemberSchema.pick({
			firstName: true,
			lastName: true,
			title: true,
			email: true,
		}),
		projects: z.array(
			z.object({
				projectName: z.string(),
				projectNumber: z.string().nullish(),
				clientName: z.string().nullish(),
				address: addressSchema, // streetName, houseNumber, zipCode, city
				substitutions: z.array(
					z.object({
						firstName: z.string(),
						lastName: z.string(),
						phone: z.string().nullish(), // accepts string | null | undefined
						email: z.string().nullish(),
					}),
				),
			}),
		),
	})
	.and(substitutionPlanNotificationContentSchema);

export const substitutionPlanNotificationInternalContentSchema = z
	.object({
		substitutionUser: z.object({
			firstName: z.string(),
			lastName: z.string(),
			email: z.string(),
			/** `users.language` as stored; null for a substitute who never chose one. */
			language: z.string().nullish(),
		}),
		projects: z.array(
			z.object({
				id: z.uuid(),
				projectName: z.string(),
				projectNumber: z.string().nullish(),
				clientName: z.string().nullish(),
				address: addressSchema, // streetName, houseNumber, zipCode, city
				note: z.string().nullish(),
			}),
		),
	})
	.and(substitutionPlanNotificationContentSchema);

export const substitutionPlanNotificationTeamContentSchema = z
	.object({
		teamMember: z.object({
			firstName: z.string(),
			lastName: z.string(),
			email: z.string(),
		}),
		projects: z.array(
			z.object({
				id: z.uuid(),
				projectName: z.string(),
				projectNumber: z.string().nullish(),
				clientName: z.string().nullish(),
				address: addressSchema, // streetName, houseNumber, zipCode, city
				note: z.string().nullish(),
				substitutions: z.array(
					z.object({
						firstName: z.string(),
						lastName: z.string(),
						phone: z.string().nullish(),
						email: z.string().nullish(),
					}),
				),
			}),
		),
	})
	.and(substitutionPlanNotificationContentSchema);

export type SubstitutionPlanNotificationExternalContentSchema = z.infer<
	typeof substitutionPlanNotificationExternalContentSchema
>;

export type SubstitutionPlanNotificationInternalContentSchema = z.infer<
	typeof substitutionPlanNotificationInternalContentSchema
>;

export type SubstitutionPlanNotificationTeamContentSchema = z.infer<
	typeof substitutionPlanNotificationTeamContentSchema
>;
